// Module
var code = "<page-header\n  title=\"'卷浏览器'\"\n  breadcrumbs=\"[\n    { label:'卷', link:'docker.volumes' },\n    { \n      label:volumeId,\n      link: 'docker.volumes.volume', \n      linkParams:{ id: volumeId }\n    }, '浏览']\"\n>\n</page-header>\n\n<volume-browser volume-id=\"volumeId\" node-name=\"nodeName\" is-upload-enabled=\"agentApiVersion > 1\" endpoint-id=\"endpointId\"></volume-browser>\n";
// Exports
var _module_exports = code;;
var path = 'app/docker/views/volumes/browse/browsevolume.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;